import React, { useCallback, useEffect, useState } from 'react';
import useStyles from './styles';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  clearProfileToEdit,
  getCommodityProfiles,
  postNewProfile,
  setCommodityProfileToEdit,
  setEditedProfile,
} from '../../redux/actions/commodityGroupsActions';
import {
  getCountries as getCountriesByRegion,
  getRegionCategory,
  getRegions,
  getStates,
} from '../../redux/actions/regionsActions';
import { snackbarShowMessage } from '../../redux/actions/snackbarActions';
import VerticalTabsMenu from './VerticalTabsMenu';
import ITemperatures from './interfaces/Temperatures';
import { IAdditionPayload } from './interfaces/AdditionPayload';
import { EditedProfilePayload } from './interfaces/EditedProfilePayload';
import { TabPanel } from './TabPanel';
import { ShowOnlyProfile } from './ShowOnlyProfile';
import { HoldingProfileForm } from './AddNewHoldingProfile';
import { Button, Grid } from '@material-ui/core';
import { AvailabilitySelector } from './AvailabilitySelector';
import { InitializeTemperature } from './helpers/InitializeTemperature';
import { isSaveButtonEnabled } from './helpers/isSaveButtonEnabled';
import { isDisabledSaveButtonEdit } from './helpers/isDisabledSaveButton';
import { temperaturesTreater } from './temperaturesTreater';
import {
  actionListener,
  getDefaultLabel,
  propertyToggle,
} from '../../utils/helpers';
import { TCategoryProductSheet } from '../../types/product';
import { InitializeCategoryProductSheet } from './helpers/InitializeProductSheet';
import { BRANDS } from '../../types/brands';
import { TEMPERATURETYPES } from '../../types/temperatureTypes';
import {
  putCategoryValuesToPayload,
  transformCategoryProductSheetToApiRequest,
} from '../../utils/transformers/productSheet';
import { COMMODITIES_SET_EDITED_PROFILE } from '../../redux/action-types/commodity-groups-types';
import store from '../../redux/store';

export default function VerticalTabs({
  setAddMode,
  addMode,
  setEditMode,
  editMode,
}) {
  const classes = useStyles();
  const { t } = useTranslation();
  const [tabValue, setTabValue] = React.useState(0);
  const [cookoutReq, setCookoutReq] = useState(true);
  const [holdingReq, setHoldingReq] = useState(true);

  const [correctiveReq, setCorrectiveReq] = useState(true);

  const [chilledReq, setChilledReq] = useState(true);
  const [cookoutReqEdit, setCookoutReqEdit] = useState(true);
  const [holdingReqEdit, setHoldingReqEdit] = useState(false);

  const [correctiveReqEdit, setCorrectiveReqEdit] = useState(true);

  const [chilledReqEdit, setChilledReqEdit] = useState(true);
  const [cookoutErrors, setCookoutErrors] = useState({});
  const [holdingErrors, setHoldingErrors] = useState({});
  const [chilledErrors, setChilledErrors] = useState({});
  const [indexToEdit, setIndexToEdit] = useState<number>(0);
  const [holdingTemperatures, setHoldingTemperatures] = useState<ITemperatures>(
    InitializeTemperature(),
  );

  const [correctiveTemperatures, setCorrectiveTemperatures] =
    useState<ITemperatures>(InitializeTemperature());

  const [disposalTemperatures, setDisposalTemperatures] =
    useState<ITemperatures>(InitializeTemperature());

  const [cookoutTemperatures, setCookoutTemperatures] = useState<ITemperatures>(
    InitializeTemperature(),
  );
  const [chilledTemperatures, setChilledTemperatures] = useState<ITemperatures>(
    InitializeTemperature(),
  );
  const [productSheet, setProductSheet] = useState<TCategoryProductSheet>(
    InitializeCategoryProductSheet(),
  );

  //Edit Mode
  const [holdingTemperaturesEdit, setHoldingTemperaturesEdit] =
    useState<ITemperatures>(InitializeTemperature());

  const [correctiveTemperaturesEdit, setCorrectiveTemperaturesEdit] =
    useState<ITemperatures>(InitializeTemperature());

  const [disposalTemperaturesEdit, setDisposalTemperaturesEdit] =
    useState<ITemperatures>(InitializeTemperature());

  const [cookoutTemperaturesEdit, setCookoutTemperaturesEdit] =
    useState<ITemperatures>(InitializeTemperature());
  const [chilledTemperaturesEdit, setChilledTemperaturesEdit] =
    useState<ITemperatures>(InitializeTemperature());
  const [productSheetEdit, setProductSheetEdit] =
    useState<TCategoryProductSheet>(InitializeCategoryProductSheet());

  //dropdown handling
  const [region, setRegion] = useState('all');
  const [country, setCountry] = useState('all');
  const [state, setState] = useState('all');
  const [regionEdit, setRegionEdit] = useState('all');
  const [countryEdit, setCountryEdit] = useState('all');
  const [stateEdit, setStateEdit] = useState('all');
  const dispatch: any = useDispatch();
  const { profileToEdit, commodity } = useSelector(
    (state: RootStateOrAny) => state.CommodityGroupsReducer,
  );
  const unitsOfMeasures = useSelector(
    (state: RootStateOrAny) => state.UnitsOfMeasuresReducer.entities,
  );

  const profiles = useSelector(
    (state: RootStateOrAny) => state.CommodityGroupsReducer.profiles,
  );
  const { countries, regions, states } = useSelector(
    (state: RootStateOrAny) => state.RegionsReducer,
  );
  const { selectedBrand } = useSelector(
    (state: RootStateOrAny) => state.UIReducer,
  );
  const { thisUser } = useSelector(
    (state: RootStateOrAny) => state.UserReducer,
  );

  //Edit mode useEffect
  useEffect(() => {
    if (profileToEdit.holdingTemperature) {
      setHoldingReqEdit(profileToEdit?.holdingTemperature?.display);
      setHoldingTemperaturesEdit(
        temperaturesTreater(profileToEdit?.holdingTemperature),
      );
    }

    if (profileToEdit.correctiveTemperature) {
      setCorrectiveReqEdit(profileToEdit?.correctiveTemperature?.display);
      setCorrectiveTemperaturesEdit(
        temperaturesTreater(profileToEdit?.correctiveTemperature),
      );
    }

    if (profileToEdit.disposalTemperature) {
      setDisposalTemperaturesEdit(
        temperaturesTreater(profileToEdit?.disposalTemperature),
      );
    }

    if (profileToEdit.heatingTemperature) {
      setCookoutReqEdit(profileToEdit?.heatingTemperature?.display);
      setCookoutTemperaturesEdit(
        temperaturesTreater(profileToEdit?.heatingTemperature),
      );
    }
    if (profileToEdit.chilledTemperature) {
      setChilledReqEdit(profileToEdit?.chilledTemperature?.display);
      setChilledTemperaturesEdit(
        temperaturesTreater(profileToEdit?.chilledTemperature),
      );
    }
    if (selectedBrand === BRANDS.TH) {
      setProductSheetEdit({
        ...profileToEdit.productSheet,
        display: profileToEdit.productSheet?.display,
        fresh: profileToEdit.productSheet?.fresh,
        shelfLife: profileToEdit.productSheet?.shelfLife || 0,
        shelfLifeUnit: profileToEdit.productSheet?.shelfLifeUnit?.id || 0,
        unitsOfMeasure: {
          default:
            profileToEdit.productSheet?.unitsOfMeasure?.units?.find(
              unit => unit.is_default,
            )?.id || 0,
          units:
            profileToEdit.productSheet?.unitsOfMeasure?.units?.map(unit =>
              unitsOfMeasures.find(each => each.id === unit.id),
            ) || [],
        },
        category: {
          isParent: profileToEdit.productSheet?.isParent || false,
        },
      });
    }
  }, [
    profileToEdit.heatingTemperature,
    profileToEdit.holdingTemperature,

    profileToEdit.correctiveTemperature,
    profileToEdit.disposalTemperature,

    profileToEdit,
    selectedBrand,
  ]);

  useEffect(() => {
    if (addMode) {
      setTabValue(profiles.length);
      setCookoutReq(true);
      setHoldingReq(true);
      setCorrectiveReq(selectedBrand === 'TH');
      setChilledReq(selectedBrand !== 'TH');
      if (selectedBrand === 'TH') {
        setProductSheet(InitializeCategoryProductSheet());
      }
    } else {
      setTabValue(0);
      setCountry('all');
      setRegion('all');
      setState('all');
    }
  }, [addMode]);

  const initializeForm = () => {
    setTabValue(0);
    dispatch(clearProfileToEdit());
    setCookoutErrors({});
    setHoldingErrors({});
    setChilledErrors({});

    if (editMode) {
      setEditMode(false);
      setChilledReqEdit(true);
      setHoldingReqEdit(true);
      setCorrectiveReqEdit(true);
      setCookoutReqEdit(true);
      setCookoutTemperaturesEdit(InitializeTemperature());
      setHoldingTemperaturesEdit(InitializeTemperature());
      setChilledTemperaturesEdit(InitializeTemperature());
      setCorrectiveTemperaturesEdit(InitializeTemperature());
      setDisposalTemperaturesEdit(InitializeTemperature());
      setProductSheetEdit(InitializeCategoryProductSheet());
      setRegionEdit('all');
      setCountryEdit('all');
      setStateEdit('all');
    } else {
      setAddMode(false);
      setCookoutTemperatures(InitializeTemperature());
      setHoldingTemperatures(InitializeTemperature());
      setChilledTemperatures(InitializeTemperature());
      setCorrectiveTemperatures(InitializeTemperature());
      setDisposalTemperatures(InitializeTemperature());
      setProductSheet(InitializeCategoryProductSheet());
      setRegion('all');
      setCountry('all');
      setState('all');
    }
  };

  const handleChangeSelectRegion = selected => {
    if (editMode) {
      setRegionEdit(selected);
      setCountryEdit('all');
      setStateEdit('all');
    } else {
      setRegion(selected);
      setCountry('all');
      setState('all');
    }
  };
  const handleChangeSelectCountry = selected => {
    if (editMode) {
      setCountryEdit(selected);
      setStateEdit('all');
    } else {
      setCountry(selected);
      setState('all');
    }
  };
  const handleChangeSelectState = selected => {
    if (editMode) {
      setStateEdit(selected);
    } else {
      setState(selected);
    }
  };

  const handleCancel = () => {
    initializeForm();
  };
  //fetch regions, countries and states for edit mode
  useEffect(() => {
    if (editMode && profileToEdit.idCommodity) {
      const result = dispatch(
        getRegions({ commodityId: profileToEdit.idCommodity }),
      );
      if (result?.data?.error_description) {
        dispatch(snackbarShowMessage('app.common.messages.getRegionsError'));
      }
    }
  }, [dispatch, profileToEdit.idCommodity, editMode]);

  useEffect(() => {
    if (editMode && profileToEdit.idCommodity && regionEdit !== 'all') {
      const result = dispatch(getCountriesByRegion(regionEdit));
      if (result?.data?.error_description) {
        dispatch(snackbarShowMessage('app.common.messages.getCountriesError'));
      }
    }
  }, [dispatch, editMode, regionEdit]);

  useEffect(() => {
    if (editMode && regionEdit !== 'all' && countryEdit !== 'all') {
      dispatch(getStates(regionEdit, countryEdit));
    }
  }, [regionEdit, dispatch, countryEdit, editMode]);
  useEffect(() => {
    const unsubscribeCommoditiesSuccess = actionListener(
      store,
      COMMODITIES_SET_EDITED_PROFILE.SUCCESS,
      () => {
        dispatch(snackbarShowMessage('equipment.holdingProfile.updateSuccess'));
      },
    );
    return () => {
      unsubscribeCommoditiesSuccess();
    };
  }, [dispatch]);
  const handleOpenEditMode = (index, profileId) => (/*event*/) => {
    setEditMode(true);
    setIndexToEdit(index);
    const editableProfile = profiles.find(profile => profile.id === profileId);
    dispatch(setCommodityProfileToEdit(editableProfile));
  };

  // creating a common property for corrective and disposal temperatures as both only exist when holding is required
  const isEnabledTemp =
    holdingReq && selectedBrand === 'TH' ? correctiveReq : false;

  const additionPayload: IAdditionPayload = {
    region: propertyToggle(region === 'all', 'GLOBAL', region),
    country: propertyToggle(country === 'all', null, Number(country)),
    state: propertyToggle(state === 'all', null, Number(state)),
    heating: cookoutReq,
    heatingDefault: false,
    heatingCookout: selectedBrand !== 'TH',
    heatingMin: propertyToggle(
      cookoutReq,
      +cookoutTemperatures?.tempMinF,
      null,
    ),
    heatingMax: propertyToggle(
      cookoutReq,
      +cookoutTemperatures?.tempMaxF,
      null,
    ),
    holding: holdingReq,
    holdingMin: propertyToggle(holdingReq, +holdingTemperatures.tempMinF, null),
    holdingMax: propertyToggle(holdingReq, +holdingTemperatures.tempMaxF, null),

    corrective: isEnabledTemp,
    correctiveMin: propertyToggle(
      isEnabledTemp,
      +correctiveTemperatures.tempMinF,
      null,
    ),
    correctiveMax: propertyToggle(
      isEnabledTemp,
      +correctiveTemperatures.tempMaxF,
      null,
    ),

    disposal: isEnabledTemp,
    disposalMin: propertyToggle(
      isEnabledTemp,
      +disposalTemperatures.tempMinF,
      null,
    ),
    disposalMax: propertyToggle(
      isEnabledTemp,
      +disposalTemperatures.tempMaxF,
      null,
    ),

    chilled: chilledReq,
    chilledMin: propertyToggle(chilledReq, +chilledTemperatures.tempMinF, null),
    chilledMax: propertyToggle(chilledReq, +chilledTemperatures.tempMaxF, null),
    productSheet: {},
  };

  const handleAddNewProfile = async () => {
    if (selectedBrand === BRANDS.TH) {
      putCategoryValuesToPayload(additionPayload, productSheet.category);
      additionPayload.productSheet =
        transformCategoryProductSheetToApiRequest(productSheet);
    } else {
      additionPayload.productSheet = {};
    }
    await dispatch(
      postNewProfile(
        commodity.commoditySpecNumber,
        additionPayload,
        selectedBrand,
      ),
    );
    dispatch(
      getCommodityProfiles(commodity?.commoditySpecNumber, {
        brand: selectedBrand,
      }),
    );
    initializeForm();
  };
  //getting regions, states and countries section for addMode:
  useEffect(() => {
    if (commodity && addMode) {
      const result = dispatch(
        getRegions({ commodityId: commodity?.commoditySpecNumber }),
      );
      result.then(regionsResult => {
        if (regionsResult?.data.length) {
          setRegion(regionsResult.data[0].id);
        }
      });
    }
  }, [addMode, dispatch, commodity.commoditySpecNumber, commodity]);

  useEffect(() => {
    if (
      region !== 'all' &&
      commodity &&
      commodity?.commoditySpecNumber &&
      addMode
    ) {
      dispatch(getCountriesByRegion(region, commodity?.commoditySpecNumber));
    }
  }, [dispatch, region, commodity.commoditySpecNumber, commodity, addMode]);

  useEffect(() => {
    if (addMode && country !== 'all' && region !== 'all') {
      const result = dispatch(getStates(region, country));
      if (result?.data?.error_description) {
        dispatch(snackbarShowMessage('app.common.messages.getStatesError'));
      }
    }
  }, [dispatch, country, region, addMode]);

  // creating a common property for corrective and disposal temperatures as both only exist when holding is required
  const isEnabledTempEdit =
    holdingReqEdit && selectedBrand === 'TH' ? correctiveReqEdit : false;

  const editedProfilePayload: EditedProfilePayload = {
    id: profileToEdit.id,
    region: propertyToggle(regionEdit === 'all', 'GLOBAL', regionEdit),
    country: propertyToggle(countryEdit === 'all', null, Number(countryEdit)),
    state: propertyToggle(stateEdit === 'all', null, Number(stateEdit)),
    heating: cookoutReqEdit,
    heatingDefault: profileToEdit.is_default,
    heatingCookout: selectedBrand !== 'TH',
    heatingMin: propertyToggle(
      cookoutReqEdit,
      +cookoutTemperaturesEdit.tempMinF,
      null,
    ),
    heatingMax: propertyToggle(
      cookoutReqEdit,
      +cookoutTemperaturesEdit.tempMaxF,
      null,
    ),
    holding: holdingReqEdit,
    holdingMin: propertyToggle(
      holdingReqEdit,
      +holdingTemperaturesEdit.tempMinF,
      null,
    ),
    holdingMax: propertyToggle(
      holdingReqEdit,
      +holdingTemperaturesEdit.tempMaxF,
      null,
    ),

    corrective: isEnabledTempEdit,
    correctiveMin: propertyToggle(
      isEnabledTempEdit,
      +correctiveTemperaturesEdit.tempMinF,
      null,
    ),
    correctiveMax: propertyToggle(
      isEnabledTempEdit,
      +correctiveTemperaturesEdit.tempMaxF,
      null,
    ),

    disposal: isEnabledTempEdit,
    disposalMin: propertyToggle(
      isEnabledTempEdit,
      +disposalTemperaturesEdit.tempMinF,
      null,
    ),
    disposalMax: propertyToggle(
      isEnabledTempEdit,
      +disposalTemperaturesEdit.tempMaxF,
      null,
    ),

    chilled: chilledReqEdit,
    chilledMin: propertyToggle(
      chilledReqEdit,
      +chilledTemperaturesEdit.tempMinF,
      null,
    ),
    chilledMax: propertyToggle(
      chilledReqEdit,
      +chilledTemperaturesEdit.tempMaxF,
      null,
    ),
    productSheet: {},
  };

  const generatedFormProfiles = () => {
    const form = [
      {
        name: propertyToggle(
          selectedBrand === BRANDS.TH,
          t('commodities.initialHeatingTemperature'),
          t('commodities.cookoutProfileTemperatures'),
        ),
        isRequired: propertyToggle(editMode, cookoutReqEdit, cookoutReq),
        setIsRequired: propertyToggle(
          editMode,
          setCookoutReqEdit,
          setCookoutReq,
        ),
        temperatures: propertyToggle(
          editMode,
          cookoutTemperaturesEdit,
          cookoutTemperatures,
        ),
        setTemperatures: propertyToggle(
          editMode,
          setCookoutTemperaturesEdit,
          setCookoutTemperatures,
        ),
        errorValidations: cookoutErrors,
        setErrors: setCookoutErrors,
        type: TEMPERATURETYPES.COOKOUT,
      },
      {
        name: t('commodities.holdingProfileTemperature'),
        isRequired: propertyToggle(editMode, holdingReqEdit, holdingReq),
        setIsRequired: propertyToggle(
          editMode,
          setHoldingReqEdit,
          setHoldingReq,
        ),
        disabled: profileToEdit.is_default,
        temperatures: propertyToggle(
          editMode,
          holdingTemperaturesEdit,
          holdingTemperatures,
        ),
        setTemperatures: propertyToggle(
          editMode,
          setHoldingTemperaturesEdit,
          setHoldingTemperatures,
        ),
        errorValidations: holdingErrors,
        setErrors: setHoldingErrors,
        type: TEMPERATURETYPES.HOLDING,
      },
    ];
    // pushing holding and corrective temperatures to the form when selected brand is TH
    if (selectedBrand === BRANDS.TH) {
      form.push(
        {
          name: t('commodities.correctiveProfileTemperatures'),
          isRequired: propertyToggle(
            editMode,
            holdingReqEdit ? correctiveReqEdit : false,
            holdingReq ? correctiveReq : false,
          ),
          setIsRequired: propertyToggle(
            editMode,
            setCorrectiveReqEdit,
            setCorrectiveReq,
          ),
          temperatures: propertyToggle(
            editMode,
            correctiveTemperaturesEdit,
            correctiveTemperatures,
          ),
          setTemperatures: propertyToggle(
            editMode,
            setCorrectiveTemperaturesEdit,
            setCorrectiveTemperatures,
          ),
          errorValidations: holdingErrors,
          setErrors: setHoldingErrors,
          type: TEMPERATURETYPES.CORRECTIVE,
        },
        {
          name: t('commodities.disposalProfileTemperatures'),
          isRequired: propertyToggle(
            editMode,
            holdingReqEdit ? correctiveReqEdit : false,
            holdingReq ? correctiveReq : false,
          ),
          setIsRequired: propertyToggle(
            editMode,
            setCorrectiveReqEdit,
            setCorrectiveReq,
          ),
          temperatures: propertyToggle(
            editMode,
            disposalTemperaturesEdit,
            disposalTemperatures,
          ),
          setTemperatures: propertyToggle(
            editMode,
            setDisposalTemperaturesEdit,
            setDisposalTemperatures,
          ),
          errorValidations: holdingErrors,
          setErrors: setHoldingErrors,
          type: TEMPERATURETYPES.DISPOSAL,
        },
      );
    } else {
      form.unshift({
        name: t('commodities.chilledProfileTemperatures'),
        isRequired: propertyToggle(editMode, chilledReqEdit, chilledReq),
        setIsRequired: propertyToggle(
          editMode,
          setChilledReqEdit,
          setChilledReq,
        ),
        temperatures: propertyToggle(
          editMode,
          chilledTemperaturesEdit,
          chilledTemperatures,
        ),
        setTemperatures: propertyToggle(
          editMode,
          setChilledTemperaturesEdit,
          setChilledTemperatures,
        ),
        errorValidations: chilledErrors,
        setErrors: setChilledErrors,
        type: TEMPERATURETYPES.CHILLED,
      });
    }
    return form;
  };

  const handleSubmitEditProfile = async () => {
    if (selectedBrand === BRANDS.TH) {
      putCategoryValuesToPayload(
        editedProfilePayload,
        productSheetEdit.category,
      );
      editedProfilePayload.productSheet =
        transformCategoryProductSheetToApiRequest(productSheetEdit);
    }
    await dispatch(
      setEditedProfile(
        editedProfilePayload,
        profileToEdit.idCommodity,
        selectedBrand,
      ),
    );
    dispatch(
      getCommodityProfiles(commodity?.commoditySpecNumber, {
        brand: selectedBrand,
      }),
    );
    initializeForm();
  };

  useEffect(() => {
    if (Object.keys(profileToEdit).length > 1) {
      setRegionEdit(profileToEdit.region || 'all');
      setCountryEdit(profileToEdit.country?.id || 'all');
      setStateEdit(profileToEdit?.state?.id || 'all');
    }
  }, [profileToEdit]);

  const getPropertiesToRender = () => {
    const properties: any[] = [];
    if (['BK', 'PLK'].includes(selectedBrand))
      properties.push({
        displayTitle: t('commodities.chilledProfileTemperatures'),
        temperatureName: 'chilledTemperature',
      });

    properties.push({
      displayTitle:
        selectedBrand === 'TH'
          ? t('commodities.initialHeatingTemperature')
          : t('commodities.cookoutProfileTemperatures'),
      temperatureName: 'heatingTemperature',
    });
    properties.push({
      displayTitle: t('commodities.holdingProfileTemperature'),
      temperatureName: 'holdingTemperature',
    });
    if (selectedBrand === 'TH') {
      properties.push(
        {
          displayTitle: t('commodities.correctiveProfileTemperatures'),
          temperatureName: 'correctiveTemperature',
        },
        {
          displayTitle: t('commodities.disposalProfileTemperatures'),
          temperatureName: 'disposalTemperature',
        },
      );
    }

    return properties;
  };

  const VerticalTabDefaultLabel = getDefaultLabel(
    state,
    country,
    region,
    countries,
    states,
  );

  return (
    <div className={classes.root}>
      <VerticalTabsMenu
        hideDefault={!addMode}
        profiles={profiles}
        value={tabValue}
        setValue={setTabValue}
        disabled={addMode || editMode}
        defaultName={VerticalTabDefaultLabel}
      />
      {editMode && (
        <TabPanel value={tabValue} index={indexToEdit}>
          <Grid container>
            <AvailabilitySelector
              name={t('commodities.productProfileAvailability')}
              regions={regions}
              region={regionEdit}
              handleChangeSelectRegion={handleChangeSelectRegion}
              countries={countries}
              country={countryEdit}
              handleChangeSelectCountry={handleChangeSelectCountry}
              states={states.map(mappedState => ({
                ...mappedState,
                name: mappedState.description,
              }))}
              state={stateEdit}
              handleChangeSelectState={handleChangeSelectState}
            />
            <HoldingProfileForm
              region={regionEdit}
              formProfiles={generatedFormProfiles()}
              productSheet={productSheetEdit}
              setProductSheet={setProductSheetEdit}
            />
            <Grid item xs={12} style={{ marginTop: 10, textAlign: 'right' }}>
              <Button
                style={{ margin: 3 }}
                variant="outlined"
                onClick={handleCancel}
              >
                {t('app.common.cancel')}
              </Button>
              <Button
                disabled={
                  !isSaveButtonEnabled(
                    generatedFormProfiles(),
                    productSheetEdit,
                    selectedBrand,
                  ) ||
                  isDisabledSaveButtonEdit(
                    generatedFormProfiles(),
                    cookoutErrors,
                    holdingErrors,
                    chilledErrors,
                  )
                }
                style={{ margin: 3 }}
                variant="outlined"
                onClick={handleSubmitEditProfile}
              >
                {t('app.common.save')}
              </Button>
            </Grid>
          </Grid>
        </TabPanel>
      )}
      {addMode && (
        <TabPanel value={tabValue} index={profiles.length}>
          <Grid container>
            <AvailabilitySelector
              name={t('commodities.productProfileAvailability')}
              regions={regions}
              region={region}
              handleChangeSelectRegion={handleChangeSelectRegion}
              countries={countries}
              country={country}
              handleChangeSelectCountry={handleChangeSelectCountry}
              states={states.map(e => ({ ...e, name: e.description }))}
              state={state}
              handleChangeSelectState={handleChangeSelectState}
            />
            <HoldingProfileForm
              region={region}
              formProfiles={generatedFormProfiles()}
              productSheet={productSheet}
              setProductSheet={setProductSheet}
            />
            <Grid item xs={12} style={{ marginTop: 10, textAlign: 'right' }}>
              <Button
                style={{ margin: 3 }}
                variant="outlined"
                onClick={handleCancel}
              >
                {t('app.common.cancel')}
              </Button>
              <Button
                disabled={
                  !isSaveButtonEnabled(
                    generatedFormProfiles(),
                    productSheet,
                    selectedBrand,
                  ) ||
                  isDisabledSaveButtonEdit(
                    generatedFormProfiles(),
                    cookoutErrors,
                    holdingErrors,
                    chilledErrors,
                  )
                }
                style={{ margin: 3 }}
                variant="outlined"
                onClick={handleAddNewProfile}
              >
                {t('app.common.save')}
              </Button>
            </Grid>
          </Grid>
        </TabPanel>
      )}
      {!addMode &&
        !editMode &&
        profiles.map((profile, index) => (
          <TabPanel value={tabValue} index={index} key={index}>
            <ShowOnlyProfile
              canEdit={thisUser.hasHoldingProfileCommodities}
              title={t('commodities.productProfileAvailability')}
              classes={classes}
              profile={profile}
              commodityGroupProductSheet={true}
              handleOpenEditMode={handleOpenEditMode}
              index={index}
              propertiesToRender={getPropertiesToRender()}
            />
          </TabPanel>
        ))}
    </div>
  );
}
